import type { ICellRendererParams } from '@mint-lib/ag-grid/community';
import { LoadingCell } from '@mint-lib/ag-grid/components';
import { TruncateText, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

import type { UserTableV2Row } from '../datasource.js';
import { isUserUpdating, type UserTableV2GridContext } from '../gridContext.js';

type Props = ICellRendererParams<
  UserTableV2Row,
  string | undefined,
  UserTableV2GridContext
>;

const EmailCell = ({ context, data, value }: Props) => {
  const isUpdating = isUserUpdating(context, data?.id);

  if (!data || isUpdating) {
    return <LoadingCell />;
  }

  const text = value == null ? '' : String(value);

  return (
    <div className="flex h-full min-w-0 items-center">
      <TruncateText tooltipClassName="max-w-none break-all">
        <div
          className={cn(
            typographyVariants({
              variant: 'bodyShort01',
              color: 'primary',
            }),
            'cursor-text select-text',
          )}
        >
          {text}
        </div>
      </TruncateText>
    </div>
  );
};

export default EmailCell;
